import { render, staticRenderFns } from "./DayReport2.vue?vue&type=template&id=b59d7012&"
import script from "./DayReport2.vue?vue&type=script&lang=js&"
export * from "./DayReport2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports